<template>
  <div class="forgot-password">
    <div class="landing-page-wrapper">
      <div class="landing-page-content">
        <div class="forgot-password">
          <h1 class="page-title">
            <div class="content color-1-100">
              <template v-if="formStatus.success">
                Login
              </template>
              <template v-else>
                Reset password
              </template>
            </div>
          </h1>
          <p class="page-description" v-if="!formStatus.success">
            Please enter below the new password for your Clear Assured account.
            It must contain at least 9 characters that include capital letters, lower case letters and numbers.
          </p>
          <div class="landing-page-login-wrapper"
               v-if="formStatus.success">
            <div class="landing-page-login-group"
                 :class="[{ 'active': loginForm.email !== '' || loginForm.emailFocus, 'has-error': loginForm.isError }]">
              <label for="landing-page-login-email">Email</label>
              <input id="landing-page-login-email"
                     :class="[{ 'border-1-50': loginForm.email !== '' || loginForm.emailFocus }]"
                     type="email"
                     data-vv-name="Email"
                     @focus="loginForm.emailFocus = true"
                     @blur="loginForm.emailFocus = false"
                     v-model="loginForm.email"/>
            </div>
            <div class="landing-page-login-group"
                 :class="[{ 'active': loginForm.password !== '' || loginForm.passwordFocus, 'has-error': loginForm.isError }]">
              <label for="landing-page-login-password">Password</label>
              <a href="#"
                 class="landing-page-login-password-show"
                 @click.prevent="showPassword('top')"></a>
              <input id="landing-page-login-password"
                     :class="[{ 'border-1-50': loginForm.password !== '' || loginForm.passwordFocus }]"
                     data-vv-name="Password"
                     :type="loginForm.passwordType"
                     @focus="loginForm.passwordFocus = true"
                     @blur="loginForm.passwordFocus = false"
                     v-model="loginForm.password"/>
            </div>
            <div class="landing-page-login-actions">
              <a href="#" class="login background-1-100"
                 :class="[{ 'active-logging': loginForm.loginInProgress }]"
                 @click.prevent="authenticate()">Login</a>
            </div>
          </div>
          <div class="landing-page-login-wrapper"
               v-if="!formStatus.success">
            <div class="landing-page-login-group"
                 :class="[{ 'active': formInfo.fos_user_resetting_form.plainPassword.first !== '' || passwordFocus, 'has-error': this.errors.has('New password') }]">
              <label for="landing-page-reset-password">New password</label>
              <a href="#"
                 class="landing-page-login-password-show"
                 @click.prevent="showPassword('password')"></a>
              <input class="landing-page-login-password"
                     ref="password"
                     @focus="passwordFocus = true"
                     @blur="passwordFocus = false"
                     id="landing-page-reset-password"
                     data-lpignore="true"
                     :type="passwordType"
                     name="New password"
                     v-validate="'required'"
                     v-model="formInfo.fos_user_resetting_form.plainPassword.first">
              <span class="form-field-error" v-if="this.errors.has('New password')">{{ this.errors.first('New password') }}</span>
            </div>
            <div class="landing-page-login-group"
                 :class="[{ 'active': formInfo.fos_user_resetting_form.plainPassword.second !== '' || retypePasswordFocus, 'has-error': this.errors.has('Retype new password') }]">
              <label for="landing-page-login-password-retype">Retype new password</label>
              <a href="#"
                 class="landing-page-login-password-show"
                 @click.prevent="showPassword('retypePassword')"></a>
              <input class="landing-page-login-password"
                     @focus="retypePasswordFocus = true"
                     @blur="retypePasswordFocus = false"
                     id="landing-page-login-password-retype"
                     data-lpignore="true"
                     :type="retypePasswordType"
                     name="Retype new password"
                     v-validate="'required|confirmed:password'"
                     v-model="formInfo.fos_user_resetting_form.plainPassword.second">
              <span class="form-field-error" v-if="this.errors.has('Retype new password')">{{ this.errors.first('Retype new password') }}</span>
            </div>
            <div class="login-form-error" aria-live="assertive">
              <template v-if="loginForm.isError">
                {{ loginForm.loginErrorMessage }}
              </template>
            </div>
            <div class="landing-page-login-actions">
              <a href="#" class="login background-1-100"
                 :class="[{ 'active-logging': resetInProgress }]"
                 @click.prevent="resetPassword()">Submit</a>
            </div>
          </div>
          <div class="landing-page-login-info">
            Having trouble accessing your account several times? <br/>
            <router-link :to="{ name: 'contact' }">Get in touch</router-link> and tell us about your problem, we’ll do our best to help you.
          </div>
          <div class="form-message"
               aria-live="assertive"
               :class="formStatus.success ? 'success' : 'error' ">
            <template v-if="this.formStatus.submitting">
              Submitting
            </template>
            <template v-if="formStatus.shown && !this.formStatus.submitting">
              <h2 v-if="formStatus.title !== ''">{{ formStatus.title }}</h2>
              <p v-if="formStatus.body !== ''">{{ formStatus.body }}</p>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'
  import api from '@/api'

  export default {
    name: 'reset',
    props: ['token'],
    data () {
      return {
        resetInProgress: false,
        passwordType: 'password',
        retypePasswordType: 'password',
        formStatus: {
          shown: false,
          success: false,
          title: '',
          body: '',
          submitting: false
        },
        passwordFocus: false,
        retypePasswordFocus: false,
        formInfo: {
          fos_user_resetting_form: {
            plainPassword: {
              first: '',
              second: ''
            }
          }
        },
        successfullyReset: false,
        isError: false,
        isToken: false,
        loginForm: {
          email: '',
          password: '',
          grantType: 'password',
          clientId: '2_659vq9a3czggcws88wcws8s4kc8gc8gcss4wog4cwcsk08ggkg',
          clientSecret: '5ncmjzrt9ps8808cskk8ogwwgwkgks8ggc0kskg0cw48s08ks4',
          emailFocus: false,
          passwordFocus: false,
          loginInProgress: false,
          isError: false,
          loginErrorMessage: '',
          passwordType: 'password'
        }
      }
    },
    methods: {
      ...mapActions([
        'redirect'
      ]),
      invalidToken () {
        this.$http.post(api.URLS.invalidToken + this.$route.params.token)
          .then((res) => {
            this.isToken = true
          })
          .catch((err) => {
            console.log(err)
            this.$router.push('/expired-token')
          })
      },
      sendFormRequest () {
        this.$router.push('/')
      },
      resetPassword () {
        this.formStatus.submitting = true
        this.$validator.validateAll().then((valid) => {
          if (!valid) {
            this.isError = true
            this.formStatus.submitting = false
            return
          }
          this.resetInProgress = true
          let token = this.$route.params.token
          this.$http.post(api.URLS.resetPassword + token, JSON.stringify(this.formInfo), {})
            .then((res) => {
              this.resetInProgress = false
              this.formStatus.success = true
              this.formStatus.title = 'Password was successfully updated.'
              this.formStatus.body = 'You can now login to your account using the new password.'
              this.formStatus.shown = true
              this.formStatus.submitting = false
            })
            .catch((err) => {
              this.resetInProgress = false
              this.formStatus.title = err.body.error.exception[0].message
              this.formStatus.body = ''
              this.formStatus.shown = true
              this.formStatus.submitting = false
            })
        })
      },
      showPassword (form) {
        if (form === 'password') {
          this.passwordType = this.passwordType === 'password' ? 'text' : 'password'
        } else {
          this.retypePasswordType = this.retypePasswordType === 'password' ? 'text' : 'password'
        }
      },
      authenticate () {
        let auth = {
          grant_type: this.loginForm.grantType,
          client_id: this.loginForm.clientId,
          client_secret: this.loginForm.clientSecret,
          username: this.loginForm.email,
          password: this.loginForm.password
        }

        this.$http.post(api.URLS.login, auth).then((res) => {
          this.isError = false
          localStorage.setItem('token', res.body.access_token)
          let headers = {headers: {'Authorization': `Bearer ${res.body.access_token}`}}
          this.$http.put(api.URLS.profile, {}, headers)
              .then((res) => {
                this.$store.commit('authLoginSuccess')
                let userData = {
                  'id': res.body.id ? res.body.id : '',
                  'firstName': res.body.first_name ? res.body.first_name : '',
                  'lastName': res.body.last_name ? res.body.last_name : '',
                  'userRole': res.body.role.slug,
                  'company': res.body.company ? res.body.company.id : null
                }
                if (['ca', 'gm'].indexOf(res.body.role.slug) > -1 && res.body.consent_status === 0) {
                  localStorage.setItem('consentHead', 'true')
                }
                localStorage.setItem('consentSeen', res.body.consent_seen)
                localStorage.setItem('userData', JSON.stringify(userData))
                localStorage.setItem('cookieFixed', true)
                localStorage.setItem('userIndustry', (res.body.company && res.body.company.industry) ? res.body.company.industry.id : 1)
                document.getElementById('app').setAttribute('data-industry', (res.body.company && res.body.company.industry) ? res.body.company.industry.id : 1)
                if (res.body.company) {
                  localStorage.setItem('userCompanyName', res.body.company.name)
                }
                if (res.body.company && res.body.company.industry) {
                  localStorage.setItem('userIndustryName', res.body.company.industry.name)
                }
                this.$store.commit('authLoginSetUsername', userData.firstName)
                this.redirect()
              })
              .catch((err) => {
                if (err.status === 401) {
                  localStorage.removeItem('token')
                  localStorage.removeItem('userData')
                  localStorage.removeItem('consentSeen')
                  localStorage.removeItem('consentHead')
                  localStorage.removeItem('userIndustryName')
                  localStorage.removeItem('userCompanyName')
                  this.loginForm.loginInProgress = false
                  this.loginForm.isError = true
                  this.loginForm.loginErrorMessage = 'Your account is inactive. Please contact support.'
                }
              })
        }).catch((err) => {
          this.loginForm.isError = true
          this.loginForm.loginErrorMessage = 'Invalid credentials'
          this.loginForm.loginInProgress = false
          console.log(err)
        })
      }
    },
    created () {
      document.title = 'Clear Assured – reset your password'
    },
    mounted () {
      this.invalidToken()
    }
  }
</script>

<style src="@/assets/scss/main/landing-page.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// Reset.vue?0d741dde